import type { FC} from 'react';
import React from 'react'
// import {styled} from '../helpers/react-helpers';
import css from './Flex.less'
import cn from 'classnames'
import {withClass} from '../helpers/react-helpers'

type Div = React.ComponentPropsWithoutRef<'div'>;

interface FlexRowProps extends Div {
    gap: React.CSSProperties['gap'];
    spaceBetween?: boolean
    spaceAround?: boolean
    spaceEvenly?: boolean
    wrap?: boolean
}

const px = (n: number | string) => typeof n === 'number' ? `${n}px` : n

export const FlexRow: FC<FlexRowProps> = ({style, className, wrap, gap, spaceBetween, spaceEvenly, spaceAround, ...otherProps}) => <div
    className={cn(className, css.flexRow,{
        [css.flexSpaceBetween]: spaceBetween,
        [css.flexSpaceEvenly]: spaceEvenly,
        [css.flexSpaceAround]: spaceAround,
    })}
    style={{gap, flexWrap: wrap ? 'wrap' : undefined, ...style}} {...otherProps} />


interface SimpleFlexProps extends Div {
    minWidth?: number | string
    maxWidth?: number | string
}


export const FlexGrow: FC<SimpleFlexProps> = ({minWidth, maxWidth, style, className, ...otherProps}) => <div
    className={cn(className, css.flexGrow)} style={{minWidth, maxWidth, ...style}} {...otherProps} />

export const FlexShrink: FC<SimpleFlexProps> = ({minWidth, maxWidth, style, className, ...otherProps}) => <div
    className={cn(className, css.flexShrink)} style={{minWidth, maxWidth, ...style}} {...otherProps} />

/** Shrink to fit content. Never expand to fill remaining width. */
export const FlexAuto = withClass<'div'>('div', css.flexAuto)

/** Fit content. Expand to full width if no other columns. */
export const FlexFullAuto = withClass<'div'>('div', css.flexFullAuto)

interface FlexFixedProps extends Div {
    width: number | string
}

// https://stackoverflow.com/a/21413841/65387
export const FlexFixed: FC<FlexFixedProps> = ({width, style, className, ...otherProps}) => <div
    className={cn(className, css.flexFixed)} style={{width, ...style}} {...otherProps} />
